<template>

    <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />
    
    <!-- breadcrumbs -->
    <nav class="sba-collection-breadcrumb z-depth-0">
      <div class="container nav-wrapper">
        <div class="sba-collection-breadcrumb-row">
          <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
            <i class="material-icons">home</i>
            <span>Dashboard</span>
          </router-link>
          <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
          <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
            <span>Provider Billing</span>
          </span>
          <span class="sba-collection-context">Provider Claims Billing</span>
        </div>
      </div>
    </nav>

    <!-- Top -->
    <div id="top"></div>

    <div class="container claim-page-shell care-billing-page-shell">
        <div class="claim-workbench sba-slide-in">
            <div class="claim-review-head">
                <div class="claim-title-row">
                    <div class="claim-title-block">
                        <label class="active teal-text">Billing Desk</label>
                        <h5>Billing Batches</h5>
                        <p>Review visit batches and submit claims when ready.</p>
                    </div>
                    <div class="claim-title-actions">
                        <button type="button" class="claim-search-toggle" :class="{ 'is-cancel': showStartPanel, disabled: !hasManualBillingSchemes }" :title="hasManualBillingSchemes ? 'Start Batch' : 'No manual billing scheme is enabled'" @click="handlePrimaryStartAction">
                            <i class="material-icons">{{ showStartPanel ? "close" : "add" }}</i>
                            <span>{{ showStartPanel ? "Cancel" : "Start Batch" }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div id="batch-start" v-if="showStartPanel">
                <StartBillingBatch @started="handleBatchStarted" @cancel="handleStartCancel" />
            </div>

            <div id="batch-filter" class="claim-filter-shell" v-show="showSearchFilters && !showStartPanel">
                <div class="claim-filter-card">
                    <FilterBilling @search="handleSearch" />
                </div>
            </div>

        <!-- <div class="row">
            <div class="col s12"> -->

                <!-- Review Marker -->
                <div id="review"></div>

                <!-- Claims -->
                <LoadingDiv v-if="!isReady" />

                <div v-else>
                    <div class="section billing-batch-section" v-if="clusters.length || isLoading">
                        <div class="card z-depth-0 grey lighten-4 billing-batch-card">
                            <div class="card-panel z-depth-0 grey lighten-5 z-depth-1 billing-batch-header">
                                <div class="row billing-batch-header-grid">
                                    <div class="col s1 hide-on-small-only">#</div>
                                    <div class="col s5 m3">Batch <small>(scheme)</small></div>
                                    <div class="col s2 m2">Encounter(s)</div>
                                    <div class="col s2 m2">Sent</div>
                                    <div class="col s2 m1">Stage</div>
                                    <div class="col s1">Payment</div>
                                    <div class="col s1 hide-on-small-only"><br /></div>
                                </div>
                            </div>

                            <div class="progress" v-if="isLoading">
                                <div class="indeterminate"></div>
                            </div>

                            <!-- Main -->
                            <div class="card-panel grey lighten-5 billing-batch-row" :class="{
                                'blue-grey lighten-5': (index + 1) % 2 === 1,
                                'is-unsubmitted': cluster.status === 'q',
                            }" v-for="(cluster, index) in clusters" :key="cluster.id">
                                <div class="row billing-batch-grid">
                                    <div class="col s12 m1 hide-on-small-only">
                                        <p class="billing-batch-index">{{ numberBadge(index) }}</p>
                                    </div>
                                    <div class="col s12 m3 billing-batch-title-cell">
                                        <h6 class="billing-batch-title">
                                            {{ toMonthYear(cluster.month_year) }} Claims
                                            <br />
                                            <small class="billing-batch-scheme">({{ HMO }} {{ cluster.scheme.name
                                            }})</small>
                                        </h6>
                                    </div>
                                    <div class="col s5 m2">
                                        <p class="billing-batch-visits" v-if="cluster.encounters.length > 1">
                                            <strong>{{ cluster.encounters.length }}</strong>
                                            <span>visits</span>
                                        </p>
                                        <p class="billing-batch-visits" v-else>
                                            <strong>{{ cluster.encounters.length }}</strong>
                                            <span>visit</span>
                                        </p>
                                    </div>
                                    <div class="col s7 m2">
                                        <p>
                                            <span class="chip billing-status-chip billing-status-unsubmitted" v-if="cluster.status === 'q'">Unsubmitted</span>
                                            <span class="billing-batch-amount" v-else><b>₦{{
                                                grossTotalSent(cluster.encounters)
                                            }}</b>
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col s4 m1">
                                        <p>
                                            <span class="chip billing-status-chip billing-status-pending"
                                                v-if="cluster.status === 'p'">Pending</span>
                                            <span class="chip billing-status-chip billing-status-muted" v-if="cluster.status === 'q'">N/A</span>
                                            <span class="chip billing-status-chip billing-status-complete"
                                                v-if="cluster.status === 'r' || cluster.status === 'v'">Completed
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col s5 m1">
                                        <p>
                                            <span class="chip billing-status-chip" :class="{
                                                'billing-status-paid': paymentStatus(cluster)?.toLowerCase() === 'paid',
                                                'billing-status-pending': paymentStatus(cluster)?.toLowerCase() === 'pending',
                                                'billing-status-other': paymentStatus(cluster)?.toLowerCase() !== 'paid' && paymentStatus(cluster)?.toLowerCase() !== 'pending' && paymentStatus(cluster)?.toLowerCase() !== 'unsubmitted',
                                            }" v-if="cluster.status === 'r' || cluster.status === 'v'">
                                            {{
                                                        checkPaid(cluster) ? 'Paid' : 'Pending'
                                                }}
                                            </span>

                                            <span class="chip billing-status-chip billing-status-muted"
                                                v-else>N/A
                                            </span>
                                        </p>
                                    </div>
                                    <div class="col s3 m1">
                                        <span v-if="cluster.status === 'q'">
                                            <a class="btn-floating red right billing-row-action billing-row-action-review"><i class="material-icons"
                                                    title="review" @click="handleReview(cluster)">edit</i></a>
                                        </span>

                                        <span v-else>
                                            <a
                                                class="btn-floating btn-medium waves-effect waves-light light-blue lighten-2 right billing-row-action billing-row-action-open"><i
                                                    class="material-icons" @click="handleReview(cluster)"
                                                    title="details">chevron_right</i></a>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- <br /> -->

                        </div>
                    </div>

                    <div class="section claim-empty-state" v-if="!clusters.length && !isLoading">
                        <div class="claim-empty-icon">
                            <i class="material-icons">receipt_long</i>
                        </div>
                        <div class="claim-empty-copy">
                            <h6>No billing batches found</h6>
                            <p>There are no provider billing clusters matching the current view.</p>
                            <span>Try another period or billing status filter.</span>
                        </div>
                    </div>

                    <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
                </div>
            <!-- </div>
        </div> -->
        </div>
    </div>
</template>

<script>
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import getItemsOfItems from "@/composables/getItemsOfItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";
import FilterBilling from "@/components/billing/FilterBillingComponent.vue";
import StartBillingBatch from "@/components/billing/StartBillingBatchComponent.vue";
import {
    capWordsFx,
} from "@/composables/fxLibrary/coreFx.js";
import {
    grossTotalSentFx,
    grossTotalApprovedFx,
    checkPaidFx,
    paymentStatusFx,
} from "@/composables/calFunction/cal";
import { getCache, addCache } from "@/composables/cache/cache";
import { HMO } from '@/laravel/config';


export default {
    name: "billingHome",
    components: { SubHeading, LoadingDiv, PaginationDiv, FilterBilling, StartBillingBatch },
    setup() {
        const response = ref(null);
        const isReady = ref(false);
        const isLoading = ref(false);
        const error = ref(null);
        const currUrl = ref(null);
        const currHook = ref(null);
        const searchTitle = ref(null);
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);
        const UIUpdate = ref(true);
        const showSearchFilters = ref(true);
        const showStartPanel = ref(false);

        // vue router
        const route = useRoute();
        const router = useRouter();

        // store
        const store = useStore();

        // config
        const providerId = store.state?.user?.account?.id;
        const isManualScheme = (scheme) => {
            return scheme?.is_manual === true || scheme?.is_manual === 1 || scheme?.is_manual === "1";
        };
        const hasManualBillingSchemes = computed(() => {
            return (store.state?.user?.schemes || []).some(isManualScheme);
        });

        // start
        onMounted(() => {
            // page name
            document.title = "All Claims Cluster";

            if (!route.hash) {
                resetBillingHomeScroll();
            }
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Billing", title: "All", icon: null, url: "billing", hash: null, });
            tabs.value.push({ id: 2, name: "Billing", title: "Review", icon: "edit", url: "billing", hash: "#review" });

            if (hasManualBillingSchemes.value) {
                tabs.value.push({ id: 3, name: "Billing", title: "Start", icon: "add", url: "billing", hash: "#batch-start" });
            }

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("All"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("All"));

            if (route.hash === "#batch-start" && hasManualBillingSchemes.value) {
                openStartPanel();
            }
        });

        // handle curr status
        const handleActive = (tab) => {
            currTab.value = tab;
            if (tab.hash === "#batch-start") {
                if (!hasManualBillingSchemes.value) {
                    router.push({ name: "billing" });
                    return;
                }

                openStartPanel();
                return;
            }
            showStartPanel.value = false;
            showSearchFilters.value = true;
            // refer
            if (tab.hash) {
                router.push({ hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // numbering
        const numberBadge = (num) => {
            return (
                (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
            );
        };

        //from functions
        const capWords = (val) => {
            return capWordsFx(val);
        };

        // total calculations (gross sent)
        const grossTotalSent = (encounters) => {
            return grossTotalSentFx(encounters);
        };

        // total calculations (gross approved)
        const grossTotalApproved = (encounters, db) => {
            return grossTotalApprovedFx(encounters, db);
        };

        // convert to Month & Year
        const toMonthYear = (val) => {
            let parts = val.split("_");
            let month = parseInt(parts[0]);
            let year = parseInt(parts[1]);
            let date = new Date(year, month - 1); // months are zero-indexed in JavaScript
            let monthName = date.toLocaleString("default", { month: "short" });
            return monthName + " " + year;
        };

        // payment status
        const checkPaid = (payment, repayment) => {
            return checkPaidFx(payment, repayment);
        };

        // payment status
        const paymentStatus = (cluster) => {
            return paymentStatusFx(cluster);
        };

        const focusBatchFilters = () => {
            showSearchFilters.value = true;
            router.push({ hash: "#batch-filter" });
        };

        const handlePrimaryStartAction = () => {
            if (!hasManualBillingSchemes.value) {
                return;
            }

            if (showStartPanel.value) {
                handleStartCancel();
            } else {
                openStartPanel();
            }
        };

        const handleStartCancel = () => {
            showStartPanel.value = false;
            showSearchFilters.value = true;
            currTab.value = tabs.value.find(x => x.title.includes("All"));
            router.push({ name: "billing" });
        };

        const handleBatchStarted = (cluster) => {
            showStartPanel.value = false;
            router.push({ name: "billingView", params: { clusterId: cluster.id } });
        };

        const openStartPanel = () => {
            showStartPanel.value = true;
            showSearchFilters.value = false;
            currTab.value = tabs.value.find(x => x.title.includes("Start"));
            window.history.replaceState(null, "", "#batch-start");
            scrollToBillingHead();
        };

        const scrollToBillingHead = () => {
            nextTick(() => {
                window.requestAnimationFrame(() => {
                    const target = document.querySelector(".claim-review-head");

                    if (!target) {
                        return;
                    }

                    const offset = 150;
                    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

                    window.scrollTo({
                        top: Math.max(top, 0),
                        behavior: "smooth",
                    });
                });
            });
        };

        const resetBillingHomeScroll = () => {
            nextTick(() => {
                window.requestAnimationFrame(() => {
                    window.requestAnimationFrame(() => {
                        window.scrollTo({
                            top: 0,
                            behavior: "auto",
                        });
                    });
                });
            });
        };

        // get function
        const getItemsFromApi = (table, id) => {

            // get item from store (cache)
            let cache = getCache(`${table}/${id}`);

            if (cache?.length) {
                response.value = cache;
            }

            (async () => {
                const { res, err } = await getItemsOfItems(table, id);

                if (res.value) {
                    response.value = res.value.data;
                    // add cache
                    addCache(`${table}/${id}`, response.value);
                    // set isEmpty to false
                    // isEmpty.value = isEmpty.value && response.value.data.length ? false : true;
                } else {
                    error.value = err.value;
                }

                // page is ready, loading is complete
                isReady.value = true;
                isLoading.value = false;
            })();
        };

        watch(
            () => store.state.realtimeAuthEvent?.event_id,
            (eventId) => {
                if (!eventId || !currUrl.value || showStartPanel.value) {
                    return;
                }

                isLoading.value = true;
                getItemsFromApi(currUrl.value, `${providerId}${currHook.value}`);
                store.commit("dismissRealtimeAuthNotice", eventId);
            }
        );


        // handle search (emitted from component)
        const handleSearch = (val) => {
            // start loading
            isLoading.value = true;
            // set current Url
            currUrl.value = val.currUrl;
            // set current Hook
            currHook.value = val.currHook;
            // set search title
            searchTitle.value = val.searchTitle;
            // get items from function
            getItemsFromApi(currUrl.value, `${providerId}${currHook.value}`);
        };

        // handle edit
        const handleReview = (cluster) => {
            router.push({ name: "billingView", params: { clusterId: cluster.id } });
        };

        // switch page
        const handlePage = (page) => {
            // start laoding
            isLoading.value = true;
            // go back up
            router.push({ hash: "#top" });
            // get new page items from function
            getItemsFromApi(currUrl.value, `${providerId}${currHook.value}&page=${page}`);
            // kill update
            UIUpdate.value = false;
        };

        // output results
        const clusters = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value.data; // get data portion
            }
        });

        // output pages
        const allPages = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value; // get all
            }
        });

        return {
            handleActive,
            home,
            currTab,
            tabs,
            capWords,
            numberBadge,
            grossTotalSent,
            grossTotalApproved,
            toMonthYear,
            checkPaid,
            paymentStatus,
            focusBatchFilters,
            handlePrimaryStartAction,
            handleStartCancel,
            handleBatchStarted,
            handlePage,
            handleSearch,
            handleReview,
            hasManualBillingSchemes,
            isReady,
            isLoading,
            error,
            searchTitle,
            showSearchFilters,
            showStartPanel,
            clusters,
            allPages,
            HMO: HMO,
        };
    },
};
</script>

<style scoped>
.progress {
    margin: 0;
    border-radius: 0;
}

.clickable {
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.clickable:hover {
    opacity: 0.8;
}

.pointable {
    cursor: default;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.pointable:hover {
    opacity: 0.8;
}

.spacer {
    padding: 2px;
}

.pointer {
    cursor: default;
}

/* base class */
.tab-custom {
    color: #747373;
    border: 1px solid white;
    background-color: white;
    display: inline-block;
    cursor: pointer;
    margin: 0 0 -1px;
    padding: 15px 25px;
    font-weight: 600;
    text-align: center;
    border-bottom: 2px solid white;
}

.tab-custom:hover {
    color: #000000 !important;
}

/* Removed (re-added)
  color: #000000;
  border: 1px solid #ddd;
  background-color: #d1f3df; */
.tab-custom-active {
    color: #000000;
    border: 1px solid #ddd;
    background-color: #d1f3df;
    display: inline-block;
    cursor: pointer;
    margin: 0 0 -1px;
    padding: 15px 25px;
    font-weight: 600;
    text-align: center;
    border-bottom: 2px solid orange;
}

/* display */
.tab-custom-section {
    padding: 20px 0 0;
    border-top: 1px solid #ddd;
}

.claim-page-shell {
    margin-top: -18px;
    padding-bottom: 12px;
    padding-top: 0;
    position: relative;
    z-index: 1;
}

:global(.sba-collection-breadcrumb) {
    background: #ffffff !important;
    background-color: #ffffff !important;
}

:global(html:has(.care-billing-page-shell)),
:global(body:has(.care-billing-page-shell)),
:global(.app-shell:has(.care-billing-page-shell)),
:global(.app-shell:has(.care-billing-page-shell) main) {
    background: var(--care-gutter-bg) !important;
    background-color: var(--care-gutter-bg) !important;
}

:global(.app-shell:has(.care-billing-page-shell)) {
    min-height: 0;
}

:global(.app-shell:has(.care-billing-page-shell) main) {
    padding-bottom: 0;
}

.claim-workbench {
    color: #263238;
    transform: none !important;
}

.claim-review-head,
.claim-filter-shell,
.claim-search-summary,
.claim-workbench .section > .card,
.claim-workbench .section > .card > .card-panel:first-child,
.claim-workbench .section > .card > .card-panel.grey.lighten-5,
.claim-workbench .section > .card > .progress,
.claim-empty-state {
    animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.claim-review-head,
.claim-filter-shell,
.claim-search-summary {
    background: #ffffff;
    border: 1px solid #c4d3d9;
    border-radius: 0;
    box-sizing: border-box;
    box-shadow: none;
    width: 100%;
}

.claim-review-head {
    align-items: center;
    border-radius: 6px;
    box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
    display: flex;
    gap: 22px;
    justify-content: space-between;
    margin-bottom: 0;
    overflow: visible;
    padding: 0;
    position: relative;
    z-index: 2;
}

.claim-review-head::before {
    border: 1px solid #c4d3d9;
    border-bottom: 0;
    border-radius: 7px 7px 0 0;
    content: "";
    height: 12px;
    left: -1px;
    pointer-events: none;
    position: absolute;
    right: -1px;
    top: -1px;
    z-index: 1;
}

.claim-title-row {
    align-items: center;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    padding: 28px 32px 24px;
    position: relative;
    width: 100%;
    z-index: 2;
}

.claim-title-block h5 {
    color: #263238;
    font-size: 1.75rem;
    font-weight: 800;
    letter-spacing: 0;
    margin: 8px 0 7px;
}

.claim-title-block p {
    color: #607d8b;
    font-size: 1rem;
    line-height: 1.45;
    margin: 0;
    max-width: 780px;
}

.claim-title-actions {
    align-items: center;
    display: flex;
    flex: 0 0 auto;
    gap: 10px;
}

.claim-search-toggle {
    align-items: center;
    background: #00897b;
    border: 1px solid #00897b;
    border-radius: 4px;
    box-shadow: 0 10px 20px -18px rgba(38, 50, 56, 0.8);
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    flex: 0 0 auto;
    font-weight: 800;
    gap: 9px;
    height: 40px;
    justify-content: center;
    letter-spacing: 0;
    min-width: 146px;
    padding: 0 16px;
    transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.claim-search-toggle i {
    color: currentColor;
    font-size: 20px;
}

.claim-search-toggle.is-cancel {
    background: #c62828;
    border-color: #c62828;
    color: #ffffff;
}

.claim-search-toggle.is-cancel i {
    color: #ffffff;
}

.claim-search-toggle:hover,
.claim-search-toggle:focus {
    background: #00796b;
    border-color: #00796b;
    box-shadow: 0 14px 24px -20px rgba(38, 50, 56, 0.85);
    color: #ffffff;
}

.claim-search-toggle:hover i,
.claim-search-toggle:focus i {
    color: #ffffff;
}

.claim-search-toggle.disabled,
.claim-search-toggle.disabled:hover,
.claim-search-toggle.disabled:focus {
    background: #eceff1;
    border-color: #cfd8dc;
    box-shadow: none;
    color: #90a4ae;
    cursor: default;
}

.claim-search-toggle.disabled i,
.claim-search-toggle.disabled:hover i,
.claim-search-toggle.disabled:focus i {
    color: #90a4ae;
}

.claim-search-toggle.is-cancel:hover,
.claim-search-toggle.is-cancel:focus {
    background: #b71c1c;
    border-color: #b71c1c;
    color: #ffffff;
}

.claim-filter-shell {
    border-color: #c4d3d9;
    border-radius: 0;
    border-top: 0;
    box-shadow: none;
    padding: 18px 24px 22px;
    position: relative;
    z-index: 3;
}

#batch-start {
    padding-top: 18px;
    scroll-margin-top: 150px;
}

.claim-filter-card {
    background: #ffffff;
    border: 1px solid #c7d3d8;
    border-radius: 0;
    box-shadow: none;
    padding: 10px;
}

.claim-filter-card :deep(.sectionx > br) {
    display: none;
}

.claim-filter-card :deep(form) {
    margin: 0;
}

.claim-filter-card :deep(.row) {
    align-items: stretch;
    display: flex;
    gap: 10px;
    margin-bottom: 0;
}

.claim-filter-card :deep(.col) {
    border: 1px solid #c7d3d8;
    border-radius: 0;
    min-width: 0;
    padding: 0 !important;
}

.claim-filter-card :deep(nav) {
    background: transparent !important;
    box-shadow: none !important;
    height: auto;
    line-height: normal;
    min-height: 52px;
}

.claim-filter-card :deep(.input-field),
.claim-filter-card :deep(.nav-wrapper) {
    background: transparent;
    height: auto;
    line-height: normal;
    margin: 0;
    min-height: 52px;
}

.claim-filter-card :deep(input),
.claim-filter-card :deep(.select-wrapper input.select-dropdown) {
    background: transparent;
    border: none !important;
    box-sizing: border-box;
    color: #263238 !important;
    font-size: 1.02rem;
    font-weight: 700;
    height: 52px !important;
    line-height: 52px;
    margin: 0;
    padding: 0 42px 0 16px !important;
    width: 100%;
}

.claim-filter-card :deep(input:focus) {
    box-shadow: inset 0 -2px 0 #00897b !important;
}

.claim-filter-card :deep(.material-icons) {
    color: #00897b !important;
    height: 52px;
    line-height: 52px;
    right: 10px;
    top: 0;
}

.claim-filter-card :deep(.dropdown-content) {
    border-top: 1px solid #dfe7ea;
    box-shadow: none;
    margin: 0;
    max-height: 190px;
    overflow-y: auto;
    position: static !important;
    transform: none !important;
    width: 100% !important;
    z-index: 1;
}

.claim-filter-card :deep(.dropdown-content li > span) {
    color: #00897b;
    line-height: 1.35;
    padding: 12px 20px;
}

.claim-search-summary {
    align-items: center;
    background: #ffffff;
    border: 1px solid #c4d3d9;
    border-radius: 0;
    border-top: 0;
    box-shadow: none;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    padding: 14px 24px;
}

.summary-label {
    color: #607d8b;
    flex: 0 0 auto;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
}

.summary-content {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: flex-end;
    min-width: 0;
    text-align: right;
}

.claim-search-summary :deep(.chip),
.summary-chip {
    background: #ffffff !important;
    border: 1px solid #80cbc4;
    border-radius: 999px;
    color: #263238 !important;
    display: inline-flex;
    font-size: 0.82rem;
    font-weight: 700;
    height: auto;
    line-height: 1.2;
    margin: 0 6px 6px 0;
    padding: 7px 12px;
}

.claim-workbench .section > .card {
    background: #ffffff !important;
    border: 1px solid #c4d3d9;
    border-radius: 0;
    box-shadow: none;
    margin-top: 18px;
    overflow: hidden;
    padding: 12px;
}

.claim-workbench .section > .card > .card-panel:first-child {
    background: #f5f7f8 !important;
    border: 1px solid #e3e8eb;
    border-radius: 0;
    box-shadow: none;
    color: #607d8b;
    font-size: 0.72rem;
    font-weight: 800;
    letter-spacing: 0;
    margin: 0 0 12px;
    padding: 13px 16px 1px;
    text-transform: uppercase;
}

.claim-workbench .section > .card > .progress {
    background: #e7ecef;
    border-radius: 0;
    height: 4px;
    margin: -12px 0 12px;
    overflow: hidden;
}

.claim-workbench .section > .card > .card-panel.grey.lighten-5 {
    border: 1px solid #e0e7ea;
    border-radius: 0;
    box-shadow: none;
    margin: 0 0 10px;
    padding: 18px 16px 8px;
}

.claim-workbench .section > .card > .card-panel.grey.lighten-5 .row {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
}

.billing-batch-header-grid {
    min-height: 38px;
}

.billing-batch-card .billing-batch-row.card-panel.grey.lighten-5 {
    background: #ffffff !important;
    border: 1px solid #d8e4e8 !important;
    margin: 0 0 12px !important;
    min-height: 88px;
    padding: 22px 20px !important;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.billing-batch-card .billing-batch-row.card-panel.grey.lighten-5.blue-grey.lighten-5 {
    background: #fbfcfc !important;
}

.billing-batch-card .billing-batch-row:hover {
    border-color: #c2d5dc !important;
    box-shadow: 0 12px 24px -24px rgba(38, 50, 56, 0.55) !important;
    transform: translateY(-1px);
}

.billing-batch-grid {
    min-height: 54px;
}

.billing-batch-index {
    align-items: center;
    background: #eef4f6;
    border: 1px solid #d4e1e5;
    color: #263238;
    display: inline-flex;
    font-size: 0.86rem;
    font-weight: 900;
    height: 34px;
    justify-content: center;
    line-height: 1;
    width: 34px;
}

.billing-batch-title-cell {
    min-width: 0;
}

.claim-workbench .billing-batch-title {
    color: #33444c;
    font-size: 1.08rem;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.22;
}

.billing-batch-scheme {
    color: #607d8b;
    display: inline-block;
    font-size: 0.78rem;
    font-weight: 400;
    line-height: 1.35;
    margin-top: 6px;
}

.claim-workbench .billing-batch-visits {
    align-items: baseline;
    color: #33444c;
    display: inline-flex;
    gap: 7px;
    line-height: 1;
}

.billing-batch-visits strong {
    font-size: 1.08rem;
    font-weight: 800;
}

.billing-batch-visits span {
    color: #78909c;
    font-size: 0.82rem;
    font-weight: 700;
}

.billing-batch-amount {
    color: #33444c;
    display: inline-flex;
    font-size: 0.96rem;
    font-weight: 800;
    line-height: 1;
}

.claim-workbench .billing-status-chip {
    align-items: center;
    border: 1px solid transparent;
    border-radius: 6px;
    display: inline-flex;
    font-size: 0.78rem;
    font-weight: 900;
    height: 40px;
    justify-content: center;
    line-height: 1;
    min-width: 60px;
    padding: 0 14px;
}

.billing-status-unsubmitted {
    background: #f8e78a !important;
    border-color: #e1cd68;
    color: #4a3d13 !important;
}

.billing-status-muted {
    background: #eceff1 !important;
    border-color: #e0e6e9;
    color: #455a64 !important;
}

.billing-status-pending,
.billing-status-other {
    background: #e5e8fa !important;
    border-color: #d2d7f5;
    color: #394064 !important;
}

.billing-status-paid,
.billing-status-complete {
    background: #dff3e3 !important;
    border-color: #c9e8cf;
    color: #1b5e20 !important;
}

.claim-workbench h6 {
    color: #263238;
    font-size: 1.06rem;
    font-weight: 700;
    line-height: 1.35;
    margin: 0;
}

.claim-workbench p {
    color: #263238;
    font-weight: 600;
    margin: 0;
}

.claim-workbench .chip {
    border-radius: 6px;
    font-size: 0.82rem;
    font-weight: 700;
    margin: 0;
}

.claim-workbench .btn-floating {
    align-items: center;
    border-radius: 0;
    box-shadow: none;
    display: inline-flex;
    justify-content: center;
}

.claim-workbench .btn-floating i {
    font-size: 20px;
}

.billing-row-action {
    border: 1px solid rgba(38, 50, 56, 0.12);
}

.billing-batch-card .billing-row-action {
    border-radius: 4px;
    box-shadow: 0 14px 22px -18px rgba(38, 50, 56, 0.55);
    height: 50px;
    transition: box-shadow 0.18s ease, transform 0.18s ease;
    width: 50px;
}

.billing-batch-card .billing-row-action:hover,
.billing-batch-card .billing-row-action:focus {
    box-shadow: 0 16px 24px -16px rgba(38, 50, 56, 0.6);
    transform: translateY(-1px);
}

.billing-batch-card .billing-row-action i {
    font-size: 22px;
}

.billing-row-action-review {
    background: #455a64 !important;
    border-color: #3b4d55;
}

.billing-row-action-open {
    background: #607d8b !important;
    border-color: #546e7a;
}

.billing-row-action-review:hover,
.billing-row-action-review:focus {
    background: #37474f !important;
    border-color: #314047;
}

.billing-row-action-open:hover,
.billing-row-action-open:focus {
    background: #546e7a !important;
    border-color: #455a64;
}

.claim-workbench .claim-empty-state {
    align-items: center;
    background: #ffffff;
    border: 1px solid #c4d3d9;
    border-radius: 0;
    box-shadow: none;
    color: #607d8b;
    display: flex;
    gap: 16px;
    margin-top: 16px;
    min-height: 150px;
    padding: 28px 30px;
    text-align: left;
}

.claim-empty-icon {
    align-items: center;
    background: #e8f3f2;
    border: 1px solid #cde8e5;
    border-radius: 0;
    color: #00897b;
    display: inline-flex;
    flex: 0 0 auto;
    height: 52px;
    justify-content: center;
    width: 52px;
}

.claim-empty-icon i {
    font-size: 27px;
}

.claim-empty-copy h6 {
    color: #263238;
    font-size: 1.02rem;
    font-weight: 800;
    line-height: 1.2;
    margin: 0;
}

.claim-empty-copy p {
    color: #607d8b;
    font-size: 0.94rem;
    line-height: 1.45;
    margin: 7px 0 0;
}

.claim-empty-copy span {
    color: #78909c;
    display: block;
    font-size: 0.82rem;
    font-weight: 700;
    margin-top: 9px;
}

.claim-workbench :deep(.pagination) {
    margin-top: 28px;
}

.claim-workbench > .claim-review-head,
.claim-workbench > .claim-filter-shell,
.claim-workbench .billing-batch-card.card,
.claim-workbench .claim-empty-state {
    box-shadow:
        -8px 0 16px -15px rgba(38, 50, 56, 0.45),
        8px 0 16px -15px rgba(38, 50, 56, 0.45),
        0 10px 18px -20px rgba(38, 50, 56, 0.35) !important;
}

@media only screen and (max-width: 992px) {
    .claim-title-row {
        align-items: flex-start;
        flex-direction: column;
    }

    .claim-page-shell {
        margin-top: -12px;
    }

    .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row {
        gap: 12px 0;
    }
}

@media only screen and (max-width: 600px) {
    .claim-review-head {
        padding: 0;
    }

    .claim-title-row {
        padding: 22px;
    }

    .claim-title-block h5 {
        font-size: 1.45rem;
    }

    .claim-title-block p {
        font-size: 0.94rem;
    }

    .claim-search-toggle {
        justify-content: space-between;
        width: 100%;
    }

    .claim-title-actions {
        align-items: stretch;
        flex-direction: column;
        width: 100%;
    }

    .claim-filter-card {
        padding: 10px;
    }

    .claim-filter-card :deep(.row) {
        flex-direction: column;
    }

    .claim-filter-card :deep(.col) {
        width: 100% !important;
    }

    .claim-search-summary {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
        padding: 12px 16px;
    }

    .summary-content {
        justify-content: flex-start;
        text-align: left;
    }

    .claim-workbench .section > .card {
        border-left: 0;
        border-right: 0;
        border-radius: 0;
        margin-left: -12px;
        margin-right: -12px;
        padding: 10px;
    }

    .claim-workbench .section > .card > .card-panel:first-child {
        display: none;
    }

    .claim-workbench .section > .card > .card-panel.grey.lighten-5 {
        border-radius: 8px;
        margin-bottom: 10px;
        padding: 16px;
    }

    .billing-batch-card .billing-batch-row.card-panel.grey.lighten-5 {
        min-height: auto;
        padding: 18px !important;
    }

    .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row {
        align-items: stretch;
        display: grid;
        gap: 12px;
        grid-template-columns: 1fr 1fr;
    }

    .billing-batch-grid {
        min-height: 0;
    }

    .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row > .col {
        margin-left: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
        width: 100% !important;
    }

    .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row > .col:nth-child(2),
    .claim-workbench .section > .card > .card-panel.grey.lighten-5 .row > .col:last-child {
        grid-column: 1 / -1;
    }

    .claim-workbench h6 {
        font-size: 1rem;
    }

    .claim-workbench p {
        font-size: 0.86rem;
    }

    .claim-workbench .chip {
        height: auto;
        line-height: 1.25;
        min-height: 30px;
        padding: 7px 10px;
        white-space: normal;
    }

    .claim-workbench .btn-floating {
        align-items: center;
        border-radius: 8px;
        display: inline-flex;
        float: none !important;
        height: 40px;
        justify-content: center;
        width: 100%;
    }

    .billing-batch-card .billing-row-action {
        height: 42px;
        width: 100%;
    }

    .claim-workbench .claim-empty-state {
        align-items: flex-start;
        flex-direction: column;
        padding: 22px;
    }
}

@media (prefers-reduced-motion: reduce) {
    .claim-review-head,
    .claim-filter-shell,
    .claim-search-summary,
    .claim-workbench .section > .card,
    .claim-workbench .section > .card > .card-panel:first-child,
    .claim-workbench .section > .card > .card-panel.grey.lighten-5,
    .claim-workbench .section > .card > .progress,
    .claim-empty-state {
        animation: none;
    }
}
</style>
